import { API_V2_BASE_URL } from "config";

// Promo живёт на API v2; абсолютный URL обходит baseUrl (v1) в fetchBaseQuery.
export const PROMO_URL = `${API_V2_BASE_URL}/promo`;

// Ручки организатора (участники, победители, draw-now) есть только в v1.
export const PROMO_V1_URL = "/promo";
